// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-methodology-js": () => import("./../../../src/pages/methodology.js" /* webpackChunkName: "component---src-pages-methodology-js" */),
  "component---src-templates-award-type-js": () => import("./../../../src/templates/award-type.js" /* webpackChunkName: "component---src-templates-award-type-js" */),
  "component---src-templates-location-award-js": () => import("./../../../src/templates/location-award.js" /* webpackChunkName: "component---src-templates-location-award-js" */),
  "component---src-templates-provider-award-js": () => import("./../../../src/templates/provider-award.js" /* webpackChunkName: "component---src-templates-provider-award-js" */)
}

